import { RefObject, useEffect, useMemo, useState } from "react";

function useOnScreen(ref: RefObject<HTMLElement>): boolean {
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(() => new IntersectionObserver(
    ([entry]) => {
      setIntersecting(entry.isIntersecting);
      observer.disconnect();
    }
  ), [])

  useEffect(() => {
    if(ref.current) {
      observer.observe(ref.current)
    }
    return () => observer.disconnect()
  }, [ref, observer])

  return isIntersecting;
}

export default useOnScreen;
